<template>
  <base-carousel
    v-if="cards?.popularDishesCards?.length"
    :items="cards.popularDishesCards"
    :breakpoints="breakpoints"
    tracking-component-name="popular_dishes"
    class="popular-dishes"
  >
    <template #header>
      <header class="popular-dishes-header">
        <h2 v-if="cards.popularDishesTitle" class="popular-dishes-header__title">
          {{ cards.popularDishesTitle }}
        </h2>
        <span v-if="cards.popularDishesDescription" class="popular-dishes-header__description">
          {{ cards.popularDishesDescription }}
        </span>
      </header>
    </template>
    <template #default="{ item }">
      <popular-dish-card :card="item" />
    </template>
  </base-carousel>
</template>

<script setup lang="ts">
import type { PopularDishesProps } from './types';
import type { PopularDishesData } from '../types';
import type { SwiperOptions } from 'swiper/types';
import BaseCarousel from '@/components/2_elements/BaseCarousel/BaseCarousel.vue';
import PopularDishCard from './PopularDishCard/PopularDishCard.vue';
import { normalizePx } from '../../../utils/scalingUtils';

withDefaults(defineProps<PopularDishesProps>(), {
  cards: () => ({}) as PopularDishesData,
});

const breakpoints: SwiperOptions['breakpoints'] = {
  0: { enabled: true, slidesPerView: 1 },
  [normalizePx(768) ?? 768]: { enabled: true, slidesPerView: 2 },
  [normalizePx(1024) ?? 1024]: { enabled: true, slidesPerView: 3 },
};
</script>

<style lang="scss">
@import './scss/PopularDishes.scss';
</style>
